module.exports = __webpack_public_path__ + "img/eg-other-04.00874a47.png";